module.exports = __webpack_public_path__ + "static/media/ham_gas_sit_spe_met.8da73f93.png";